/* eslint-disable import/first */
import React from 'react';

/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import {
  Avatar,
  Checkbox,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Radio,
} from '@material-ui/core';
const { selectCurrentCountry } = Slices.profileSlice;
const { selectCountryValidations } = Slices.configSlice;
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import css from './index.module.scss';

function ProductOption({ option, type, id, onChange, checked, menuCondiment }) {
  // const imgBaseUrl = useSelector(selectBaseURL);
  const { assets } = option;
  const imgUrl = assets[0].src;
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  const optionName = option?.items?.length
    ? option?.items?.[0]?.title
    : menuCondiment?.title || option?.title;
  return (
    <ListItem button component="label" htmlFor={id} ContainerProps={{ className: css.root }}>
      <Avatar variant="square" alt={optionName} src={`${imgUrl}`} className={css.image} />

      <ListItemText
        primary={`${optionName} ${
          option.price
            ? ' ( ' + decimalChecker(option.price) + ' ' + countryValidations.currency + ')'
            : ''
        }`}
        className={css.title}
      />
      <ListItemSecondaryAction className={css.radioCheck}>
        {type === 'checkbox' ? (
          // <Checkbox
          //   edge="end"
          //   onChange={handleToggle(value)}
          //   checked={checked.indexOf(value) !== -1}
          // />
          <Checkbox id={id} edge="end" onChange={onChange} checked={checked ? true : false} />
        ) : null}

        {type === 'radio' ? (
          // <Checkbox
          //   edge="end"
          //   onChange={handleToggle(value)}
          //   checked={checked.indexOf(value) !== -1}
          // />
          <Radio
            id={id}
            color="primary"
            edge="end"
            onChange={onChange}
            checked={checked ? true : false}
          />
        ) : null}
      </ListItemSecondaryAction>
    </ListItem>
  );
}

export default ProductOption;
